import './integrations/g4flex-crm.js'; // Integration with G4Flex CRM 
jQuery(function($) {
  $(document).ready(function() {

  //==============================================
  // SLIDERS
  //==============================================

    function initializeSliders() {
      if (typeof Swiper === "undefined") return; // Verifica se Swiper está carregado

      new Swiper(".bannerSpace", {
          slidesPerView: "auto",
          loop: true,
          // autoplay: { delay: 3000, disableOnInteraction: false },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true,
          },
      });

    }
    initializeSliders();

  //==============================================
  // FORMULÁRIO
  //==============================================

   document.addEventListener('DOMContentLoaded', function () {
     const form = document.querySelector('.wpcf7-form'); // Seleciona o formulário
     const submitButton = form.querySelector('.wpcf7-submit'); // Seleciona o botão de envio
     const requiredFields = ['nome', 'mail', 'telefone']; // IDs dos campos obrigatórios
   
     function checkFields() {
       let allFilled = requiredFields.every(id => {
         let field = form.querySelector(`[name="${id}"]`);
         return field && field.value.trim() !== '';
       });
   
       if (allFilled) {
         submitButton.style.setProperty('display', 'block', 'important');
       } else {
         submitButton.style.setProperty('display', 'none', 'important');
       }
     }
   
     requiredFields.forEach(id => {
       let field = form.querySelector(`[name="${id}"]`);
       if (field) {
         field.addEventListener('input', checkFields);
       }
     });
   
     checkFields(); // Executa a verificação inicial
   });

    
  });
});

